import { useHistory } from 'react-router';

type ActionHeaderProps = {
    header: string;
    subHeader?: string;
};

const ActionHeader = ({ header = '', subHeader }: ActionHeaderProps) => {
    const history = useHistory();
    return (
        <h1 className="heading">
            <a
                role="button"
                tabIndex={0}
                aria-label="Go back"
                onClick={() => history.goBack()}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        history.goBack();
                    }
                }}
            >
                <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
            </a>
            {header}
            {subHeader && <span>{subHeader}</span>}
        </h1>
    );
};

export default ActionHeader;
